import React from 'react';

export const ShutterFaceFrame = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 88.4 88.4"
      {...props}
    >
      <defs>
        <circle id="prefix__a" cx={44.2} cy={44.2} r={43.5} />
      </defs>
      <clipPath id="prefix__b">
        <use xlinkHref="#prefix__a" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__b)">
        <path fill="#ecf7f9" d="M53.6 32.5L7.9 3.2 3 3.7l47.6 30.5z" />
        <path
          fill="#c8dfeb"
          d="M3 3.7h-6.5l47.2 32.9-.8 17.5 6.8-4.6.9-15.3z"
        />
        <g
          fill="#414142"
          stroke="#241f20"
          strokeWidth={0.762}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M54.6 31.9c-.2.1-6.1 3.5-6.1 3.5l11.9 7.1 6.1-3.8-11.9-6.8z" />
          <path d="M48.5 35.3v14.6l11.9-7.5z" />
        </g>
        <g
          fill="#bbbebf"
          stroke="#233762"
          strokeWidth={0.762}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M87.8 77.5v12.3H48.2V50.5zM48.2 50.5c.5-.2 20.6-13.6 20.6-13.6l19.3 12.3-.3 28.3-39.6-27z" />
        </g>
        <path
          fill="#fffffd"
          stroke="#233762"
          strokeWidth={0.762}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M-.6 5.4l25.7 18.3.9-.7 18.5 13.1-1.6 52.6H-.6z"
        />
        <path
          fill="none"
          stroke="#233762"
          strokeWidth={0.762}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M-.6 15.9l16.8 12.7-1.3.7L34 42.5l10.5-6.4M34 42.5l.3 46.2M14.9 29.3l3.3 59.4M-.6 61.1l18.1 15.3M-.6 78.9l11.1 9.8"
        />
        <g
          stroke="#233762"
          strokeWidth={0.762}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path
            d="M35.7 66.6l-.4 22.1h23.9L61.4 61l-14.1-9.6-2.9 1.8v4.6l2 1.4s-7.3 4.6-9.3 5.9c-2.8 1.7-.5 2.7.5 2.1 1.1-.5 2.1-1 2.1-1l5.2 3.1s-1.1.9-1.7 1.5c-.6.6.1 2.5 2.2 1.2s15.8-11 15.8-11M37 88.7l.3-21.4M44.5 72.3l-.8 16.4"
            fill="#fffffd"
          />
          <path d="M39.6 66.1c-.8 1.5 2.5 3.7 5.2 3.1" fill="none" />
          <path
            d="M37.3 68.3s3.8 3.3 5.6 3M42.4 71.3l-.5 17.4"
            fill="#fffffd"
          />
        </g>
        <path
          fill="#bbbebf"
          stroke="#233762"
          strokeWidth={0.762}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M47.3 51.4l.9-.9"
        />
      </g>
      <circle
        cx={44.2}
        cy={44.2}
        r={43.5}
        fill="none"
        stroke="#233762"
        strokeWidth={1.449}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
      <g>
        <defs>
          <circle id="prefix__c" cx={42} cy={-73.6} r={43.5} />
        </defs>
        <clipPath id="prefix__d">
          <use xlinkHref="#prefix__c" overflow="visible" />
        </clipPath>
        <g clipPath="url(#prefix__d)">
          <path
            fill="#fff"
            stroke="#233762"
            strokeWidth={4.853}
            strokeMiterlimit={10}
            d="M47.4 2.2L-16.1-4v-31.8l81.5 7.2z"
          />
        </g>
      </g>
    </svg>
  );
};
